<section class="brand-trust pt-5 pb-5 pt-xl-0">
    <div class="container">
        <div class="content-heading mb-4" *ngIf="brandslist.length>0">
            <h2 class="page-sub-title cv-text-dark">Featured Vehicles</h2>
        </div>
        <div class="carousel-sec">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 brand-you-trust-new-gallery">
                <div class="top-desc child">
                    <ngx-slick-carousel #slickModal="slick-carousel" class="carousel thumbs gallery"
                        [config]="descSlider" >
                        <div ngxSlickItem class="item" *ngFor="let item of brandslist">
                            <div class="item-heading mb-0 mb-xl-3">
                              <h4 class="mb-0">{{item.product_description?item.product_description:'-'}}</h4>
                            </div>
                            <div class="row item-row g-4">
                                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 item-grid">
                                    <div class="border-line"></div>
                                    <div class="content pt-3">
                                        <h6>GVW</h6>
                                        <h4>{{item.gvw_s?item.gvw_s:'-'}}</h4>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 item-grid">
                                    <div class="border-line"></div>
                                    <div class="content pt-3">
                                        <h6>Engine</h6>
                                        <h4>{{item.engine_type_s?item.engine_type_s:'-'}}</h4>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 item-grid">
                                    <div class="border-line"></div>
                                    <div class="content pt-3">
                                        <h6>No of Wheel </h6>
                                        <h4>{{item?.no_wheels?item?.no_wheels:'-'}}</h4>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 item-grid">
                                    <div class="border-line"></div>
                                    <div class="content pt-3">
                                        <h6>Features</h6>
                                        <h4 [ngStyle]="{'max-height': isScrollable() ? '400px' : 'none', 'overflow-y': isScrollable() ? 'auto' : 'hidden'}"
                                            #featureDiv>{{item.column_three?item.column_three:'-'}}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                
                    </ngx-slick-carousel>
                </div>
                <div class="bottom-img child  text-center">
                    <ngx-slick-carousel #slickHLModal="slick-carousel" class="carousel imagepreview right gallery2"
                        [config]="imageSlider">
                        <div ngxSlickItem class="item" *ngFor="let item of brandslist">
                          <img src="{{item.images[0].image_url}}" class="img-fluid"
                          style="max-height: 100%" loading="lazy">
                          <div class="text-center slider-cta justify-content-center gap-2 mt-4">
                            <button type="button" style="min-width: 160px;"
                                class="btn btn-outline-primary btn-grad-outline-primary btn-brand btn-lg  ps-3 pe-3 ps-sm-5 pe-sm-5 pt-3 pb-3"
                                (click)="gotoProductDetail(item.sub_lob,item.lob_seo,item.ppl_seo,item.pl, item.id);clevertapPDP(item)">View
                                Details</button>
                            <button type="button" style="min-width: 160px;"
                                (click)="bookNow(item.sub_lob,item.lob_seo,item.ppl_seo,item.pl, item.id)"
                                class="btn btn-primary btn-lg btn-grad-primary btn-brand ps-3 pe-3 ps-sm-5 pe-sm-5 pt-3 pb-3">Book
                                now at {{item?.down_payment | currency:'INR':'symbol':'4.0-0'}}</button>
                        </div>
                        </div>
                    </ngx-slick-carousel>
                </div>
            </div>
        </div>
    </div>
</section>
